import { render, staticRenderFns } from "./InitialLayout.vue?vue&type=template&id=6a905692&scoped=true"
import script from "./InitialLayout.vue?vue&type=script&lang=js"
export * from "./InitialLayout.vue?vue&type=script&lang=js"
import style0 from "./InitialLayout.vue?vue&type=style&index=0&id=6a905692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a905692",
  null
  
)

export default component.exports